import React from 'react';
import { DataTypeProvider } from '@devexpress/dx-react-grid';
import { documentTypeOptions, renderDocumentTypeOption } from '../_Utils/AppDocuCommon';

const DocumentTypeFormatter = ({ row }) => {
  const option = documentTypeOptions.find(opt => opt.name === row.document_type);
  // Usa renderDocumentTypeOption ma wrappa la label in <b>
  if (!option) return row.document_type;
  return (
    <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
      <span style={{ display: 'flex', alignItems: 'center' }}>
        {renderDocumentTypeOption({}, option.name).props.children[0]}
      </span>
      <b style={{ position: 'relative', top: 2 }}>{option.label}</b>
    </span>
  );
};

const DocumentTypeTypeProvider = props => <DataTypeProvider formatterComponent={DocumentTypeFormatter} {...props} />

export default DocumentTypeTypeProvider;
